import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import {
  ref,
  onMounted,
  Teleport,
  shallowRef,
  onUnmounted,
  onBeforeMount,
} from "vue";
import axios, { AxiosResponse } from "axios";
// Components
import SumPopupSection from "../components/SumPopupSection.vue";
import SumSection from "../components/SumSection.vue";
import HeaderBlock from "../components/blocks/HeaderBlock.vue";
import AIBlock from "../components/blocks/AIBlock.vue";
import FAQBlock from "../components/blocks/FAQBlock.vue";
import TagsBlock from "../components/blocks/TagsBlock.vue";
import ContentBlock from "../components/blocks/ContentBlock.vue";
import AnchorBlock from "../components/blocks/AnchorBlock.vue";
import ArrowBlock from "../components/blocks/ArrowBlock.vue";
import LogoBlock from "../components/blocks/LogoBlock.vue";
// Hooks
import { useDebounce } from "../hooks/debounce";
// Types
import {
  ISettings,
  ISummaryList,
  ISummary,
  ITag,
  IItem,
} from "../types/settings";

const FRSelector = "fsumsection";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    settings: {},
    summaryList: {}
  },
  setup(__props: any) {

// Modules
const props = __props;

const debouncedGetSummary = useDebounce(getSummaryList, 50);

let mutationObserver: MutationObserver | null = null;
let intersectionObserver: IntersectionObserver | null = null;

const ANCHOR_TYPES = {
  BUTTON: 0,
  FRAME: 2,
};
const widgetTypes = {
  MAIN_TYPE: 0,
  POPUP_TYPE: 1,
};

const summaryList = ref<ISummaryList>();
const waitList = ref<Array<{trackedNode: Element, settings: ISummary, idParam: string, type: string}>>([]);
const componentsList = ref({
  [widgetTypes.MAIN_TYPE]: shallowRef(SumSection),
  [widgetTypes.POPUP_TYPE]: shallowRef(SumPopupSection),
});
const items = ref<Array<IItem>>([]);

onBeforeMount(() => {
  summaryList.value = props.summaryList;
});

onMounted(() => {
  init();

  mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.removedNodes) {
        handleNodeRemoved(node);
      }

      for (const node of mutation.addedNodes) {
        handleNodeAdded(node);
      }
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // intersectionObserver = new IntersectionObserver(
  //   (entries) => {
  //     for (const entry of entries) {
  //       const item = items.value.find((i) => i.el === entry.target);
  //       if (!item) continue;

  //       if (entry.isIntersecting) {
  //         intersectionObserver?.unobserve(entry.target);
  //       }
  //     }
  //   },
  //   { rootMargin: "300px" }
  // );
  // items.value.forEach((item) => intersectionObserver?.observe(item.el));
});

onUnmounted(() => {
  mutationObserver?.disconnect();
  // intersectionObserver?.disconnect();
});

function swipeToMarket(item: IItem, type: number = 0) {
  const realType = typeof type === "number" ? type : 0;
  
  if (!item.settings.anchor) return;
  if (realType !== item.settings.anchor.type) return;
  
  const market = document.querySelector(item.settings.anchor.selector);

  if (!market) return;

  const marketPosition = market.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: marketPosition,
    behavior: "smooth",
  });
}

function getTagsList(tags: ITag, idParam: string) {
  if (!summaryList.value) return;

  const productSummary = summaryList.value[idParam];
  let list: Array<string> = [];

  if (tags.positive && tags.positive.isShow) {
    list = [...productSummary.summary[tags.positive.jsonParam]];
  }

  if (tags.negative && tags.negative.isShow) {
    list = [...list, ...productSummary.summary[tags.negative.jsonParam]];
  }

  return list;
}

function getDescription(description: { jsonParam: "overall_impression"; position: number; }, idParam: string) {
  if (!summaryList.value) return;

  const productSummary = summaryList.value[idParam];

  return productSummary.summary[description.jsonParam];
}

function getSummaryList() {
  const ids = waitList.value.map(summary => `&${summary.type}[]=${summary.idParam}`).join('');

  axios
    .get(`${props.settings.srcDomain}/fb/reviews-summary?embed_id=${props.settings.embedId}${ids}&with_settings=1`)
    .then((response: AxiosResponse<{ settings: ISettings, summaryList: ISummaryList }>) => {
        if (response && response.data.summaryList) {
          Object.keys(response.data.summaryList).forEach((summaryId) => {
            if (!summaryList.value) return;

            summaryList.value[summaryId] = response.data.summaryList[summaryId];
          });
        }
        waitList.value.forEach((waitItem) => {
          elementInit(
            waitItem.trackedNode,
            waitItem.settings,
            waitItem.idParam,
            waitItem.type
          );
        });
      }
    )
    .catch((error) => {
      console.log('error');
      console.log(error);
    });
}

function removeTrackedItem(target: Element, selector: string) {
  if (!selector) {
    return;
  }

  intersectionObserver?.unobserve(target);
  items.value = items.value.filter((item) => {
    return item.el !== target || item.settings.selector !== selector;
  });
}

function handleNodeRemoved(node: Node) {
  if (node.nodeType !== 1) {
    return;
  }

  const element = node as HTMLElement;
  const removeNode = (trackedNode: Element) => {
    if (!(trackedNode instanceof HTMLElement)) {
      return;
    }

    const settings = props.settings.summary.find((summary) => {
      return typeof summary.selector === 'string'
        && trackedNode.classList.contains(summary.selector);
    });

    if (!settings) {
      return;
    }

    removeTrackedItem(trackedNode, settings.selector);
  };

  if (element.nodeName.toLowerCase() === FRSelector) {
    removeNode(element);
  }

  element.querySelectorAll(FRSelector).forEach((trackedNode) => {
    removeNode(trackedNode);
  });
}

function handleNodeAdded(node: Node) {
  if (node.nodeType !== 1) {
    return;
  }

  const element = node as HTMLElement;
  const addNode = (trackedNode: Element) => {
    if (!(trackedNode instanceof HTMLElement)) {
      return;
    }

    const skuParam = element.getAttribute("sku");
    const groupParam = element.getAttribute("group");
    const type = skuParam ? "sku" : "group";

    const settings = props.settings.summary.find((summary) => {
      return typeof summary.selector === 'string'
        && trackedNode.classList.contains(summary.selector);
    });

    if (!settings || (!skuParam && !groupParam) || !summaryList.value) {
      return;
    }

    if (summaryList.value[(skuParam || groupParam) as string]) {
      elementInit(trackedNode, settings, (skuParam || groupParam) as string, type);
    } else {
      waitList.value.push({ trackedNode, settings, idParam: (skuParam || groupParam) as string, type });
      debouncedGetSummary();
    }
  };

  if (element.nodeName.toLowerCase() === FRSelector) {
    addNode(element);
  }

  element.querySelectorAll(FRSelector).forEach((trackedNode) => {
    addNode(trackedNode);
  });
}

function elementInit(domElement: Element, settings: ISummary, idParam: string, type: string) {
  const isAlreadyTracked = items.value.some((item) => item.el === domElement);

  if (isAlreadyTracked) {
    return;
  }

  if (!summaryList.value || !summaryList.value[idParam] || isAlreadyTracked) {
    return;
  }

  items.value.push({ el: domElement, type: settings.view.type, settings, idParam, idType: type });
}

function init() {
  const elements = document.querySelectorAll(FRSelector);

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];

    if (!(element instanceof HTMLElement)) {
      continue;
    }

    const skuParam = element.getAttribute("sku");
    const groupParam = element.getAttribute("group");
    const type = skuParam ? "sku" : "group";

    const settings = props.settings.summary.find((summary) => {
      return typeof summary.selector === 'string'
        && element.classList.contains(summary.selector)
    });

    if (!settings || (!skuParam && !groupParam)) {
      continue;
    }

    elementInit(element, settings, (skuParam || groupParam) as string, type);
  }
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
      return (_openBlock(), _createBlock(_Teleport, {
        key: index,
        to: item.el
      }, [
        (item.settings)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(componentsList.value[item.type]), {
              key: 0,
              viewSettings: item.settings.view,
              onSwipeToMarket: ($event: any) => (swipeToMarket(item, ANCHOR_TYPES.FRAME))
            }, _createSlots({
              logo: _withCtx(() => [
                _createVNode(LogoBlock, {
                  isHideFrisbuyIcon: item.settings.view?.hideBrand
                }, null, 8, ["isHideFrisbuyIcon"])
              ]),
              _: 2
            }, [
              (item.settings.tags && item.settings.tags.position !== 0)
                ? {
                    name: "tags",
                    fn: _withCtx(() => [
                      _createVNode(TagsBlock, {
                        tags: getTagsList(item.settings.tags, item.idParam)
                      }, null, 8, ["tags"])
                    ]),
                    key: "0"
                  }
                : undefined,
              (item.settings.header.position !== 0)
                ? {
                    name: "header",
                    fn: _withCtx(() => [
                      _createVNode(HeaderBlock, {
                        text: item.settings.header?.text,
                        isShowAiIcon: item.settings.header.isShowAiIcon
                      }, _createSlots({ _: 2 }, [
                        (
                item.settings.additionalAnchor &&
                item.settings.additionalAnchor.position !== 0
              )
                          ? {
                              name: "anchor",
                              fn: _withCtx(() => [
                                _createVNode(AnchorBlock, {
                                  text: item.settings.additionalAnchor.text,
                                  onSwipeToMarket: ($event: any) => (swipeToMarket(item, ANCHOR_TYPES.BUTTON))
                                }, null, 8, ["text", "onSwipeToMarket"])
                              ]),
                              key: "0"
                            }
                          : undefined,
                        ([1, 3].includes(item.settings.ai?.position))
                          ? {
                              name: `ai-`+item.settings.ai?.position,
                              fn: _withCtx(() => [
                                _createVNode(AIBlock, {
                                  text: item.settings.ai.text,
                                  count: item.settings.ai.count,
                                  anchorText: item.settings.ai.anchorText,
                                  onSwipeToMarket: ($event: any) => (swipeToMarket(item, ANCHOR_TYPES.BUTTON))
                                }, null, 8, ["text", "count", "anchorText", "onSwipeToMarket"])
                              ]),
                              key: "1"
                            }
                          : undefined,
                        (
                item.settings.faq?.position !== 0 && item.settings.faq?.text
              )
                          ? {
                              name: "faq",
                              fn: _withCtx(() => [
                                _createVNode(FAQBlock, {
                                  text: item.settings.faq.text
                                }, null, 8, ["text"])
                              ]),
                              key: "2"
                            }
                          : undefined
                      ]), 1032, ["text", "isShowAiIcon"])
                    ]),
                    key: "1"
                  }
                : undefined,
              (item.settings.description?.position === 1)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      _createVNode(ContentBlock, {
                        text: getDescription(item.settings.description, item.idParam)
                      }, null, 8, ["text"])
                    ]),
                    key: "2"
                  }
                : undefined,
              (item.settings.ai?.position === 2)
                ? {
                    name: "ai-2",
                    fn: _withCtx(() => [
                      _createVNode(AIBlock, {
                        text: item.settings.ai.text,
                        count: item.settings.ai.count,
                        anchorText: item.settings.ai.anchorText,
                        onSwipeToMarket: ($event: any) => (swipeToMarket(item, ANCHOR_TYPES.BUTTON))
                      }, null, 8, ["text", "count", "anchorText", "onSwipeToMarket"])
                    ]),
                    key: "3"
                  }
                : undefined,
              (item.settings.arrow && item.settings.view.type !== 1)
                ? {
                    name: "arrow",
                    fn: _withCtx(() => [
                      _createVNode(ArrowBlock, {
                        direction: item.settings.arrow.position,
                        offset: item.settings.arrow.offset
                      }, null, 8, ["direction", "offset"])
                    ]),
                    key: "4"
                  }
                : undefined
            ]), 1064, ["viewSettings", "onSwipeToMarket"]))
          : _createCommentVNode("", true)
      ], 8, ["to"]))
    }), 128)),
    _createElementVNode("div", {
      innerHTML: props.settings.html_title_block
    }, null, 8, _hoisted_1)
  ]))
}
}

})